// extracted by mini-css-extract-plugin
export default {"tertiary-icon":"CF7DWwlIXavthK425mEAFTcBHYKfaLqED2RYdYbpzZI=","icon":"_3xFucqrFEuYW8C2hju-oupASSqPQK0sgu6e2mLtghXY="};